import { formatMoney } from '@betterment/js-runtime';
import { Box, Heading, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { format } from 'date-fns';

import { urlBuilder } from '../../../../../Shared/urlBuilder';
import { MajorPurchaseSettingsPurpose } from '../../../data';

type Props = {
  purpose: MajorPurchaseSettingsPurpose;
};

export const MajorPurchaseTargetSection = ({ purpose }: Props) => {
  const { majorPurchaseTarget: target, goalId } = purpose;
  const currentPath = window.location.pathname;
  const editUrl = urlBuilder.appGoalsEditPurpose.absolute({
    goal_id: goalId,
    skip_to_step: 'target',
    return_to: currentPath,
  });

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.200' }}>
      <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Heading variant="title100">Plan settings</Heading>
        <SambaAutoLink to={editUrl}>Edit</SambaAutoLink>
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <Text variant="text50">Target amount</Text>
        <Text>{target.amount ? formatMoney(target.amount) : 'Not set'}</Text>
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <Text variant="text50">Target date</Text>
        <Text>{target.date ? format(target.date, 'MMM yyyy') : 'Not set'}</Text>
      </Box>
    </Box>
  );
};
